import { jsx as _jsx } from "react/jsx-runtime";
import { StyledSmall } from './styles';
export var AssistiveText = function (_a) {
  var _b = _a.error,
    error = _b === void 0 ? false : _b,
    children = _a.children;
  return _jsx(StyledSmall, {
    error: error,
    children: children
  });
};